export const getItem = key => {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (e) {
    console.log('Local Storage getItem error:', e)
  }
}

export const setItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.log('Local Storage setItem error:', e)
  }
}

export const removeItem = key => {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    console.log('Local Storage removeItem error:', e)
  }
}
